module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-600.7e06644.woff";